import Vue from 'vue'
import './registerServiceWorker'
import './sass/main.scss'
import vuetify from './plugins/vuetify/index.js'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'
import { App } from './app/index.js'
import { ValidationProvider } from 'vee-validate'
import '@mdi/font/css/materialdesignicons.min.css'

sync(store, router)

Vue.component('ValidationProvider', ValidationProvider)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
